/**
 * "Deprecated"
 *    Do not use these colours, they will be removed in a future release.
 *
 * "Never added"
 *    These were never added to the colour library, but have been found hard-coded into apps.
 *    If you come accross these, don't use them, use the colour mentioned next to it instead.
 */
var colors = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  white: '#FFFFFF',
  blackAlpha: {
    700: 'rgba(0, 0, 0, 0.7)'
  },
  grey: {
    100: '#FCFCFC',
    // Eng
    200: '#F5F5F5',
    // Eng
    250: '#F1F1F1',
    // Eng & WAL
    270: '#E5E5E5',
    // WAL
    280: '#EEEEEE',
    // WAL
    300: '#EAEAEA',
    // Eng & NI
    400: '#DDDDDD',
    // Eng & WAL
    450: '#CCCCCC',
    // WAL
    500: '#C1C1C1',
    // Eng
    600: '#A8A8A8',
    // Eng
    650: '#666666',
    // Deprecated - use grey.850
    700: '#838388',
    // Eng
    800: '#6D6D6D',
    // Eng & NI
    850: '#666666',
    // WAL
    900: '#363636',
    // Eng
    950: '#323232',
    // WAL
    970: '#232323',
    // Deprecated - use grey.980
    980: '#1F1F1F',
    // WAL Black
    // 990: '#191919', Never added - use grey.980
    1000: '#0F213A',
    // Deprecated - use blue.900
    1010: '#B5B5B5',
    // WAL
    1020: '#F8F8F8',
    // ENG
    1030: '#999999' // WAL - check with Guy
  },

  blue: {
    100: '#ABD3FF',
    // Eng
    200: '#00CAFF',
    // Eng
    250: '#4C93FF',
    // WAL
    300: '#4CAAF0',
    // Eng
    400: '#3B7DC5',
    // WAL
    450: '#05487A',
    // Deprecated - use blue.700
    500: '#2182EB',
    // Deprecated - use blue.550
    550: '#1B76D8',
    // Eng
    600: '#0360A6',
    // Eng & WAL Primary blue
    700: '#05487A',
    // Eng
    800: '#1F446d',
    // WAL
    900: '#0F213A',
    // ENG
    // 1000: '#343a40', Never added - use grey.950
    // 1100: '#3A7DC6', Never added - use blue.400
    1130: '#EBF7FF',
    // ENG
    1140: '#D4EEFF',
    // ENG & WAL & NI
    1150: '#CEDEF0',
    // ENG & NI
    1160: '#1076BC' //
  },

  red: {
    100: '#FFE4E5',
    // WAL
    200: '#FEA8A9',
    // WAL
    300: '#DB7777',
    // WAL
    400: '#D81F1F',
    // WAL
    500: '#AA1111',
    // WAL
    600: '#7E0A0E',
    // WAL
    700: '#D0011C',
    // Eng
    800: '#D50000',
    // WAL
    900: '#FF0021',
    // Deprecated - use red.1000
    1000: '#FF0000',
    // Eng
    1050: '#FFF3F3' // ENG
  },

  green: {
    200: '#CDF7D4',
    // WAL
    325: '#7ED321',
    // Eng
    400: '#29A537',
    // Deprecated - use green.500
    500: '#34AA40',
    // Eng
    600: '#019E1E',
    // WAL
    700: '#01B723',
    // Eng & WAL
    800: '#B3E264',
    // Eng
    900: '#E6FFE6',
    // ENG
    1000: '#F6FFF6' // ENG
  },

  neutral: {
    1: '#7FAED1',
    // Deprecated - use grey.900
    2: '#D4EEFF',
    // Deprecated - use blue.1140
    3: '#EBF7FF',
    // Deprecated - use blue.1130
    4: '#F7FCFF',
    // Deprecated - use blue.1130
    5: '#CEDEF0',
    // Deprecated - use blue.1140
    6: '#EBF2F9',
    // Deprecated - use blue.1130
    7: '#ABD3FF',
    // Deprecated - use blue.100
    8: '#F9FCFF',
    // Deprecated - use blue.1130
    9: '#FFF3F3',
    // Deprecated - use red.1050
    10: '#E6FFE6',
    // Deprecated - use green.900
    11: '#F6FFF6',
    // Deprecated - use green.1000
    12: '#FFFDE3',
    // Deprecated - use yellow.900
    13: '#FFFEF4',
    // Deprecated - use yellow.900
    14: '#F6FBFF' // Deprecated - use blue.1130
    // 15: '#CFCFCE', Never added - use grey.450
    // 16: '#EEECEA', Never added - use grey.300
    // 17: '#F0F0F0', Never added - use grey.250
    // 18: '#fefafb', Never added - use Red1050
    // 19: '#F8F8F8', Never added - use grey.1020
    // 20: '#E9E9E9', Never added - use grey.300
    // 21: '#EBF2FA', Never added - use grey.1140
  },

  yellow: {
    100: '#FFF5CE',
    // WAL
    200: '#FFD530',
    // WAL
    500: '#F5A623',
    // Deprecated - use orange.700
    600: '#FF8000',
    // Deprecated - use orange.600
    // 700: '#ffd000', Never added - use yellow.200
    800: '#FFDE00',
    // Eng
    900: '#FFFDE3' // Eng
  },

  orange: {
    100: '#FFF5CE',
    // Deprecated - use yellow.100
    200: '#FFD530',
    // Deprecated - use yellow.200
    300: '#FFDAB5',
    // WAL
    600: '#FF8000',
    // WAL
    700: '#F5A623' // ENG
    // 800: '#FF9900', Never added - use orange.700
    // 900: '#f9bb5c', Never added - use orange.700
  },

  purple: {
    100: '#A05CB3',
    // Eng
    200: '#9B4F94',
    // Deprecated - use purple.100
    300: '#A82B71',
    // WAL
    400: '#772C53',
    // WAL
    500: '#632A5D',
    // WAL
    600: '#7F3195' // Eng
  }
};

export default colors;